module.exports = __webpack_public_path__ + "img/Flotte.4e7e4620.jpg";